import Comment from './Comment.js';
import EachBlock from './EachBlock.js';
import Element from './Element.js';
import IfBlock from './IfBlock.js';
import MustacheTag from './MustacheTag.js';
import RawMustacheTag from './RawMustacheTag.js';
import Text from './Text.js';
import YieldTag from './YieldTag.js';

export default {
	Comment,
	EachBlock,
	Element,
	IfBlock,
	MustacheTag,
	RawMustacheTag,
	Text,
	YieldTag
};
